import React from "react";
import { motion } from "framer-motion";
import SEO from "../components/SEO";

export default function ContactPage() {
  return (
    <div className="min-h-screen pt-32 pb-24 px-6 md:px-12 flex items-center justify-center" data-testid="contact-page">
      <SEO title="Contact" description="Get in touch with 3T. We'd love to hear from you." />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center"
      >
        <p className="font-mono text-[#FFD700] text-sm tracking-[0.3em] mb-4">CONTACT</p>
        <a
          href="mailto:hello@think3t.com.au"
          className="font-heading text-5xl md:text-7xl tracking-tight hover:text-[#FFD700] transition-colors"
          data-testid="contact-email-link"
        >
          Let's Talk
        </a>
      </motion.div>
    </div>
  );
}
